import Header from "./packages/Header";
import Footer from "./packages/Footer";
import NavHeader from "./packages/common/NavHeader";
import NavFooter from "./packages/common/NavFooter";
import { createHeader } from "./packages/Header/entry";
import useSwitchAccount from "./packages/Header/hooks/useSwitchAccount";
import PopOver from "./packages/PopOver";
import { CHATBOT_PARAMS_SYNC, dispatchChatbotParamsSync } from "./packages/common/CustomEvent";

export {
  Header,
  Footer,
  NavHeader,
  NavFooter,
  createHeader,
  useSwitchAccount,
  PopOver,
  CHATBOT_PARAMS_SYNC,
  dispatchChatbotParamsSync
};
export type { ChatbotParamsSyncDetail } from "./packages/common/CustomEvent";
export type {
  UserInfo,
  FuturesTradeMode,
  SpotTradeMode,
  NavAppBridge,
  NavAppSnapshot,
  TradeModeLabels
} from "./packages/Header/types";
